/* eslint-disable max-lines */
const ar = {
  nav: {
    home: "الرئيسية",
    drops: "الإصدارات",
    upcomingDrops: "كتالوج الخزنة",
    cinema: "سينما",
    archive: "الخزانة مغلقة",
    activeDrops: "إصدارات نشطة",
    contact: "اتصل بنا",
    signIn: "تسجيل الدخول",
    apply: "ادخل الخزانة",
    enterCollezione: "ادخل الخزانة",
    signOut: "تسجيل الخروج",
    hiddenCollezione: "خزانة سرّية",
    privacy: "سياسة الخصوصية",
  },
  hero: {
    overline: "تأسس ٢٠٢٦ — خزانة سرّية",
    headline1: "Garage Drops.",
    headline2: "لمن يقتني الحكايات، لا المنتجات.",
    subtitle:
      "أرشيف خاص لقطع سينمائية، سيارات أسطورية معاد بناؤها، ومركبات نادرة للمقتنين. تُطلق دون إنذار وتختفي دون تفسير.",
    teaserLabel: "يصل الإصدار خلال",
    liveBadge: "إصدار قائم · للأعضاء فقط",
    nextDropPrefix: "الإصدار القادم —",
    viewDrops: "استعرض الإصدارات",
    apply: "ادخل الخزانة",
    scroll: "مرّر",
  },
  countdown: {
    days: "أيام",
    hours: "ساعات",
    minutes: "دقائق",
    seconds: "ثوانٍ",
    live: "الإصدار مباشر الآن",
    closes: "يُغلق الإصدار خلال",
    imminent: "وشيك · الإعلان قريباً",
  },
  manifesto: {
    overline: "البيان",
    body:
      "نحن لا نُدير دار مزادات. لا نبيع لمن يعرض السعر الأعلى. نُطلق قطعة نادرة واحدة في كل مرة، ثم تختفي.",
    pillars: [
      { n: "٠١", t: "مُختار", d: "كل إصدار يُرمَّم ويُصوَّر ويُوثَّق داخلياً." },
      { n: "٠٢", t: "مُرقَّم", d: "كل قطعة تحمل شهادة مُتسلسلة. لا نسخ مكرّرة." },
      { n: "٠٣", t: "مُخفي", d: "تفاصيل الأعضاء تظهر فقط بعد التسجيل." },
    ],
  },
  teaser: {
    overline: "قريباً",
    headline: "شيء نادر قيد التحضير.",
    body:
      "الإصدار التالي مغلق داخل الخزانة. تقدّم للعضوية لتستلم الإعلان قبل أي شخص آخر.",
    apply: "تقدّم للحصول على وصول مبكر",
    signIn: "تسجيل الدخول",
  },
  cinema: {
    overline: "سينما · Garage Drops",
    headline: "الخزانة، تتحرّك.",
    body:
      "مقاطع فيديو مختارة: من خلف الكواليس، عمليات الترميم، رحلات سينمائية. تتغيّر الاختيارات دون إشعار.",
    publicOverline: "السلسلة العامة",
    publicTitle: "لقطات متاحة للجميع.",
    exclusiveOverline: "السينما الحصرية",
    exclusiveTitle: "فقط لمن دخل الخزانة.",
    exclusiveLockedHeadline: "هناك سلسلة ثانية، محجوزة.",
    exclusiveLockedBody: "ادخل الخزانة لاكتشاف كل شيء.",
    exit: "إغلاق",
  },
  contact: {
    overline: "تواصل · Garage Drops",
    headline: "اكتب لنا. نردّ شخصياً.",
    body: "للاستفسارات الخاصة، التعاون، البيع والإيداع.",
    directOverline: "بريد مباشر",
    directHeadline: "تفضّل الكتابة مباشرة؟",
    directBody: "نردّ خلال 24 ساعة.",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    email: "البريد الإلكتروني",
    country: "الدولة",
    message: "الرسالة",
    messagePlaceholder: "أرغب بمعلومات...",
    submit: "إرسال الرسالة",
    submitting: "جارٍ التشفير…",
    successText: "تم استلام الرسالة",
    successSub: "سنردّ عليك شخصياً.",
    error: "تعذّر الإرسال. حاول مرة أخرى.",
  },
  releases: {
    overline: "الإصدارات الحالية",
    headline: "الآن داخل الخزانة.",
    allDrops: "كل الإصدارات →",
  },
  membership: {
    overline: "العضوية",
    headline: "بعض الإصدارات تظهر فقط حين يُفتح الباب.",
    body:
      "العضوية مجانية. اختر بلدك، اختر كلمة سرّ، وافتح الأرشيف — كل إصدار، كل قصة، كل صورة.",
    apply: "ادخل الخزانة",
  },
  drops: {
    overline: "الخزانة",
    headline: "الإصدارات الحالية.",
    subtitle:
      "كل إصدار يعيش هنا لفترة قصيرة فقط. بعد انتهاء العدّ التنازلي، تنتقل القطعة إلى مجموعة خاصة أو إلى الأرشيف.",
    empty: "لا توجد إصدارات معروضة حالياً. الخزانة بين إصدارين.",
    loading: "جارٍ التحميل…",
    membersOnly: "للأعضاء فقط",
    live: "مباشر الآن",
    unlockingOverline: "حالة الخزانة",
    unlockingHeadline: "إصدار Garage Drops القادم يُفتح قريباً",
    unlockingMystery: "بعض الأبواب لا تُفتح إلا في الوقت المناسب.",
    showcaseLabel: "أرشيف الخزانة — مختار بلا أسماء",
  },
  drop: {
    backLink: "العودة إلى الإصدارات",
    membersOnlyHeadline: "هذا الإصدار محجوز للدائرة الداخلية.",
    lockedOverline: "إصدار قريب",
    lockedHeadline: "هذا الإصدار على وشك أن يُكشف.",
    lockedBody: "ستظهر التفاصيل هنا فور وصول العدّ التنازلي إلى الصفر. ابقَ قريباً — الخزانة تفتح قريباً.",
    backHome: "العودة إلى الرئيسية",
    membersOnlyBody:
      "تقدّم للعضوية لفتح الصور والمواصفات والقصة والعدّ التنازلي.",
    apply: "انضم الآن",
    signIn: "تسجيل الدخول",
    object: "القطعة",
    specs: "المواصفات",
    gallery: "المعرض",
    story: "القصة",
    notFound: "لم يتم العثور على الإصدار.",
    backToCollezione: "العودة إلى الخزانة",
    teaserOverline: "إصدار قادم",
    teaserHeadline: "دليل واحد فقط الآن.",
    teaserBody: "سيُكشف الإصدار كاملاً عند إطلاقه. ابقَ في الخزانة وسنُعلمك أولاً.",
    price: "السعر",
    priceOnRequest: "عند الطلب",
    interested: "أنا مهتم",
    inCatalogOverline: "في الكتالوج",
    inCatalogHeadline: "غير متاح للبيع حاليًا.",
    inCatalogBody:
      "يتم إصدار قطعة واحدة فقط رسميًا في كل مرة من خلال نظام الإسقاط السينمائي. هذه المركبة موجودة في الأرشيف الخاص وقد تعود عندما تستدعي الإشارة ذلك.",
    inCatalogMemberBody:
      "هذه المركبة ليست معروضة للبيع حاليًا لكنها جزء من المجموعة الخاصة. املأ النموذج أدناه لطلب معلومات تفصيلية.",
    inCatalogCta: "كن عضوًا",
    categories: {
      esterno: "الخارج",
      interno: "الداخل",
      sx: "الجانب الأيسر",
      dx: "الجانب الأيمن",
      sopra: "من الأعلى",
      sotto: "من الأسفل",
      particolari: "تفاصيل",
      restauro: "ترميم · صور وفيديو",
      video: "فيديو",
    },
  },
  signalPrivileges: {
    overline: "امتيازات الإشارة",
    headline: "ما تفتحه داخل الخزانة.",
    body: "الإشارة خطٌّ خاص. أسماء قليلة، وصول مبكر، وبثوث لا تمرّ عبر القنوات العامة.",
    items: [
      "وصول مبكر إلى الإصدارات الخاصة",
      "مركبات لم تُنشر علناً",
      "بثوث سرّية قبل الإصدار",
      "مفاوضات Concierge مخصّصة",
      "الأولوية للإصدارات القادمة",
      "بثوث سينمائية كاملة داخل الخزانة",
      "الوصول إلى الأرشيف الخاص",
    ],
    footer: "الإشارة حصرية. عدد قليل فقط.",
  },
  howItWorks: {
    overline: "كيف يعمل",
    headline: "خمس خطوات. إصدار كامل.",
    steps: [
      "يُحضَّر الإصدار في الخفاء.",
      "يستقبل الأعضاء الإشارة أوّلاً.",
      "تظهر المركبة لوقت محدود.",
      "تمرّ المفاوضات عبر Concierge.",
      "يدخل الإصدار الأرشيف ويختفي.",
    ],
  },
  archive: {
    overline: "سرّي · أرشيف مغلق",
    headline: "الخزانة مغلقة.",
    body:
      "مركبات عبرت الخزانة واختفت. قصص منتهية. بثٌّ منتهٍ.",
    empty: "لا توجد بثوث منتهية بعد. ستظهر الإشارات المنتهية هنا.",
    statusLabels: {
      ended: "انتهت الإشارة",
      closed: "البث مغلق",
      locked: "إصدار مقفل",
      lost: "إشارة مفقودة",
      archived: "مؤرشف",
    },
    whispers: [
      "قد تعود الإشارة.",
      "حالة التوفّر غير معروفة.",
      "البث منتهٍ.",
      "القصة مغلقة.",
      "لا تأكيد على العودة.",
    ],
  },
  auth: {
    loginOverline: "تسجيل الدخول",
    loginHeadline: "الخزانة تعرفك.",
    loginBody: "أدخل بياناتك لفتح الأرشيف.",
    email: "البريد الإلكتروني",
    passwordLabel: "كلمة السرّ",
    submitLogin: "تسجيل الدخول",
    submittingLogin: "جارٍ التحقق…",
    notMember: "لست عضواً بعد؟",
    applyLink: "ادخل الخزانة",

    registerOverline: "انضم",
    registerHeadline: "ادخل إلى الأرشيف.",
    registerBody: "العضوية مجانية وتبقى كذلك. أخبرنا أين أنت.",
    country: "الدولة",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    passwordMin: "كلمة السرّ (٦ أحرف على الأقل)",
    privacyConsent1: "لقد قرأت ووافقت على",
    privacyConsentLink: "سياسة الخصوصية",
    privacyConsent2:
      "وأوافق على معالجة بياناتي وفقاً للائحة GDPR.",
    submitRegister: "افتح الخزانة",
    submittingRegister: "جارٍ الفتح…",
    alreadyMember: "أنت بالفعل في الداخل؟",
    signInLink: "تسجيل الدخول",

    welcomeBack: "أهلاً بعودتك إلى الخزانة.",
    welcomeNew: "أهلاً بك. الخزانة مفتوحة الآن.",
    privacyRequired: "يجب عليك قبول سياسة الخصوصية.",
    cannotSignIn: "تعذّر تسجيل الدخول.",
    cannotRegister: "تعذّر إنشاء الحساب.",
  },
  newsletter: {
    overline: "النشرة البريدية",
    headline: "تُعلن الإصدارات قبل ظهورها.",
    body:
      "بدون رسائل مزعجة، بدون ضجيج. رسالة سينمائية واحدة عند إطلاق شيء نادر.",
    yourEmail: "بريدك الإلكتروني",
    placeholder: "you@example.com",
    subscribe: "اشترك",
    submitting: "...",
    success: "أنت في القائمة. ابقَ قرب صندوق بريدك.",
    fail: "تعذّر الاشتراك. حاول مرة أخرى.",
  },
  counter: {
    overline: "الدائرة الداخلية",
    membersSuffix: "من المقتنين يحملون المفاتيح",
  },
  concierge: {
    label: "الكونسيرج",
    open: "تحدّث مع الكونسيرج",
    title: "الكونسيرج",
    subtitle: "اسأل أي شيء عن الخزانة.",
    placeholder: "اكتب رسالتك…",
    send: "إرسال",
    welcome: "أنا كونسيرج Garage Drops. سأرشدك خلال الخزانة — الإصدارات، العضوية، الأرشيف. اسأل أي شيء.",
    typing: "جارٍ إعداد الردّ…",
    error: "الخط متوقّف لحظة. حاول مرة أخرى بعد قليل.",
    close: "إغلاق",
  },
  intro: {
    line1: "الوصول إلى الشبكة الخاصة",
    line2: "فتح الخزانة",
    lineGlitch: "// إشارة // إشارة //",
    skip: "تخطّي",
    label: "Garage Drops · وصول مقيّد",
    check1: "اتصال آمن",
    check2: "تعريف الزائر",
    check3: "فتح الأرشيف",
    granted: "تم منح الوصول",
    welcome: "أهلاً بك في الخزانة",
  },
  signal: {
    overline: "إشارة خاصة",
    headline: "بثّ واحد فقط، عند إطلاق شيء نادر.",
    body: "لا ضجيج سوقي. لا رسائل مزعجة. تُعلَن الإصدارات هنا قبل أن تظهر في أي مكان آخر.",
    placeholder: "بريدك@الخاص.com",
    submit: "انضم إلى الإشارة",
    submitting: "جارٍ الإرسال…",
    successText: "تم استلام البثّ",
    successSub: "ابقَ قرب صندوق بريدك.",
    error: "تعذّر الانضمام. حاول مرة أخرى.",
    explainerLabel: "ماذا يحدث عند الانضمام",
    explainer1: "بريد إلكتروني فقط — لا حساب ولا كلمة مرور.",
    explainer2: "بثّ واحد قبل 24 ساعة من كل إصدار.",
    explainer3: "لا رسائل مزعجة. إلغاء الاشتراك بنقرة واحدة.",
  },
  offer: {
    overline: "طلب خاص",
    signedInOverline: "● مسجَّل الدخول كـ",
    useOtherEmail: "استخدم بريداً آخر",
    useMyData: "استخدم حسابي",
    headline: "مهتم؟ اترك أثرك.",
    body: "أدخل بياناتك وما تودّ معرفته: السعر، الحالة، التوفر. سنتواصل معك شخصياً وبسرّية.",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    name: "الاسم",
    email: "البريد الإلكتروني",
    country: "الدولة",
    phone: "الهاتف (اختياري)",
    amount: "قيمة العرض",
    message: "رسالتك",
    messagePlaceholder: "أرغب في معرفة السعر · أهتم بزيارة خاصة · أطلب معلومات حول...",
    submit: "أنا مهتم",
    submitting: "جارٍ التشفير…",
    privacyNote: "مشفّر · ردّ شخصي خلال 24 ساعة",
    successText: "تم استلام الطلب",
    successSub: "سيتواصل معك مسؤولنا قريباً.",
    error: "تعذّر الإرسال. حاول مرة أخرى.",
  },
  presentation: {
    featuredOverline: "الإصدار الحالي",
    liveNow: "مباشر الآن",
    countdownLabel: "يُغلق الإصدار خلال",
    viewFullDrop: "عرض الإصدار الكامل",
    apply: "ادخل الخزانة",
    objectOverline: "القطعة",
    galleryOverline: "المعرض",
    specsOverline: "المواصفات",
    storyOverline: "القصة",
    closingLine: "عندما ينتهي العدّ التنازلي، تختفي هذه القطعة.",
    lockedHeadline: "هذا الإصدار مغلق.",
    lockedBody:
      "تقدّم للعضوية لفتح الصور والمواصفات والقصة وراء القطعة.",
    archiveLinkOverline: "الأرشيف",
    archiveLinkBody: "تصفّح الإصدارات التي انتقلت بالفعل إلى مجموعات خاصة ←",
  },
  footer: {
    description:
      "خزانة رقمية سرّية لإصدارات نادرة من السيارات والقطع السينمائية للمقتنين.",
    navigateOverline: "تصفّح",
    legalOverline: "قانوني",
    legal: {
      privacy: "سياسة الخصوصية",
      cookies: "سياسة ملفات تعريف الارتباط",
      terms: "شروط الخدمة",
    },
    nav: {
      home: "الرئيسية",
      drops: "الإصدارات الحالية",
      archive: "الأرشيف",
      register: "ادخل الخزانة",
      signIn: "تسجيل الدخول",
    },
    rights: "© {year} Garage Drops",
    tagline: "تفتح الخزانة عند الغروب",
    disclaimer:
      "قطعة من مجموعتي الخاصة. بيع خاص. تباع كما هي، دون ضمان أو حق إرجاع.",
  },
  privacy: {
    overline: "قانوني",
    title: "سياسة الخصوصية",
    updated:
      "آخر تحديث: فبراير ٢٠٢٦ · متوافق مع GDPR الأوروبي (لائحة 2016/679) والمرسوم الإيطالي 196/2003.",
    s1Title: "١. وحدة التحكّم بالبيانات",
    s1Body:
      "Garage Drops (\"المنصة\") هي وحدة التحكّم بالبيانات الشخصية التي يتم جمعها عبر هذا الموقع. لأي استفسار، تواصل معنا على",
    s2Title: "٢. البيانات التي نجمعها",
    s2Intro: "نعالج فئات البيانات التالية:",
    s2List: [
      "بيانات الحساب — البريد الإلكتروني، كلمة سرّ مشفّرة، الدولة.",
      "اشتراك النشرة — البريد الإلكتروني، الدولة (اختياري)، الطابع الزمني.",
      "بيانات تقنية — عنوان IP، وكيل المتصفح، سجلات أساسية (تُحفظ ٩٠ يوماً).",
    ],
    s3Title: "٣. الأساس القانوني والغرض",
    s3Body:
      "نعالج بياناتك على الأسس التالية: (أ) ضرورة تعاقدية لتقديم العضوية والوصول إلى الإصدارات؛ (ب) الموافقة لاشتراك النشرة، يمكن سحبها في أي وقت؛ (ج) المصلحة المشروعة لمنع الاحتيال وسلامة المنصة.",
    s4Title: "٤. سياسة ملفات تعريف الارتباط",
    s4Body:
      "تستخدم Garage Drops فقط الكوكيز التقنية الضرورية (كوكيز مصادقة httpOnly). لا توجد كوكيز للتتبّع أو الإعلانات أو التحليلات من أطراف ثالثة.",
    s5Title: "٥. الاحتفاظ بالبيانات",
    s5Body:
      "تُحفظ بيانات الحساب طيلة العضوية ولمدة ٢٤ شهراً بعد طلب الحذف لأغراض السجلات القانونية. بيانات النشرة تُحفظ حتى إلغاء الاشتراك. السجلات التقنية تُحفظ ٩٠ يوماً.",
    s6Title: "٦. مشاركة البيانات",
    s6Body:
      "لا نبيع بياناتك. نشاركها فقط مع المعالجين الفرعيين الضروريين لتشغيل المنصة: استضافة سحابية (داخل الاتحاد الأوروبي)، إرسال البريد (Resend، UE/US مع البنود التعاقدية القياسية)، وتخزين الكائنات (داخل بنية Emergent).",
    s7Title: "٧. حقوقك (المواد ١٥-٢٢ من GDPR)",
    s7Intro: "لك الحق في:",
    s7List: [
      "الوصول إلى بياناتك الشخصية والحصول على نسخة منها.",
      "طلب تصحيح البيانات غير الدقيقة.",
      "طلب الحذف (الحق في النسيان).",
      "تقييد المعالجة أو الاعتراض عليها.",
      "إمكانية نقل البيانات.",
      "سحب الموافقة في أي وقت دون التأثير على المشروعية السابقة.",
      "تقديم شكوى إلى الهيئة الإيطالية لحماية البيانات الشخصية.",
    ],
    s7Outro: "لممارسة أي من هذه الحقوق، اكتب إلى",
    s8Title: "٨. الأمان",
    s8Body:
      "تُحفظ كلمات السرّ مشفّرة بـ bcrypt. تتم الاتصالات عبر HTTPS. توكنات المصادقة محفوظة في كوكيز httpOnly Secure. الوصول إلى أدوات الإدارة محميّ بالمصادقة وبمسار سرّي.",
    s9Title: "٩. شروط الخدمة",
    s9Body:
      "باستخدامك للمنصة، فإنك توافق على هذه الشروط. العضوية مجانية ويمكن إلغاؤها وفقاً لتقديرنا في حالة سوء الاستخدام. تبقى جميع الإصدارات والصور والمحتوى التحريري ملكاً لـ Garage Drops أو الحرفيين والمرمّمين والمصوّرين الأصليين المعتمدين.",
    s10Title: "١٠. التعديلات على هذه السياسة",
    s10Body:
      "قد نُحدِّث سياسة الخصوصية من حينٍ لآخر. سنُخطر الأعضاء عبر البريد الإلكتروني بأي تغيير جوهري.",
  },
  upcoming: {
    overline: "المجموعة الخاصة",
    headline: "كتالوج الخزنة.",
    subtitle:
      "المجموعة الخاصة الكاملة. قطعة واحدة فقط معروضة رسميًا للبيع في كل مرة، والباقي في الكتالوج. يمكن للأعضاء طلب معلومات عن أي طراز.",
    empty: "الكتالوج قيد الإعداد. تابع هذه الصفحة.",
    locked: "مقفل",
    filterAll: "الكل",
    filterAuto: "Auto",
    filterMoto: "Moto",
  },
  quickInquiry: {
    overline: "طلب سريع",
    headline: "هل لديك سؤال؟ راسلنا.",
    body: "بدون تسجيل. ملاحظة قصيرة، سنرد عليك بسرية.",
    name: "الاسم",
    email: "البريد الإلكتروني",
    message: "رسالتك",
    send: "إرسال الطلب",
    sent: "تم الإرسال. سنرد عليك قريبًا.",
    error: "فشل الإرسال. حاول مجددًا.",
    memberHook: "هل تريد رؤية الكتالوج الكامل؟",
    memberCta: "كن عضوًا — وصول كامل إلى الخزنة",
  },
  welcome: {
    overline: "أهلًا بك",
    headline: "ما هو Garage Drops.",
    body1:
      "Garage Drops هي مجموعة خاصة من السيارات النادرة والدراجات النارية النادرة، المُرمّمة والمختارة بعناية، من مجموعتي الشخصية ومن مجموعات خاصة منتقاة.",
    body2:
      "تُقدَّم كل مركبة من خلال إصدار سينمائي مخصص. مركبة واحدة فقط معروضة رسميًا للبيع في كل مرة، بينما تبقى الأخريات محفوظة داخل الخزنة.",
    body3:
      "قبل النشر، تخضع كل مركبة لفحوصات واختبارات على الطريق. وعندما لا يتوفر ترميم كامل موثّق، تُفحص المركبة وتُختبر بواسطتنا وبواسطة ورشتنا المعتمدة، لضمان أدائها السليم وكامل الشفافية للمالك المستقبلي.",
    body4:
      "بيع خاص: كل مركبة من مجموعتي الشخصية أو من مجموعات خاصة مختارة، وتُباع كما هي، دون ضمان أو حق إرجاع.",
    languageLabel: "اللغة",
    privacyPrefix: "بالمتابعة، فإنك تُقرّ بأنك قرأت",
    privacyLink: "سياسة الخصوصية",
    continue: "ادخل الخزنة",
  },
  signalPrivileges: {
    overline: "مزايا الأعضاء",
    headline: "ما يفتحه عضوية الخزنة.",
    body: "كن عضوًا للوصول إلى كتالوج الخزنة الكامل وطلب معلومات خاصة حول النماذج غير المعروضة للبيع حاليًا.",
    items: [
      "وصول كامل إلى الكتالوج",
      "قصة وصور وتفاصيل كل مركبة — حتى التي ليست للبيع",
      "استفسارات خاصة عن أي طراز",
    ],
    footer: "قطعة واحدة فقط للبيع في كل مرة. الباقي يعيش في الكتالوج.",
  },
};

export default ar;
